// import {insertAfter, insertBefore} from '../../lib/scripts/utilities';
import {dimensions} from '../../lib/scripts/viewportDimensions.es6';
export default function( window ) {
  if ( dimensions.mobile_700 ) {
    // window.adQueue.push( {type: 'adCall', data: {adSlot: 'Mobile_Pos2'}} );
  } else {
    window.adQueue.push( {type: 'adCall', data: {adSlot: 'Mobile_Pos2'}} );
    if (dimensions.skyscraper_1200) {
      window.adQueue.push( {type: 'adCall', data: {adSlot: 'skyscraper'}} );
    }
  }
}
